import { logger } from '@/common/log';

export const logShowBenefitCheckoutButton = ({ is_free_shipping, product_count, is_seckill_label, is_free_shipping_label }) => {
    logger.sendShow({
        action: 'CHECK_OUT_BUTTON',
        params: {
            is_free_shipping,
            product_count,
            is_seckill_label: is_seckill_label > 0 ? 1 : 0,
            is_free_shipping_label: is_free_shipping_label && !is_seckill_label ? 1 : 0,
        },
    });
};

export const logClickBenefitCheckoutButton = ({ is_free_shipping, product_count, is_seckill_label, is_free_shipping_label }) => {
    logger.sendClick({
        action: 'CHECK_OUT_BUTTON',
        params: {
            is_free_shipping,
            product_count,
            is_seckill_label: is_seckill_label > 0 ? 1 : 0,
            is_free_shipping_label: is_free_shipping_label && !is_seckill_label ? 1 : 0,
        },
    });
};

export const logClickCheckoutButton = (is_free_shipping) => {
    logger.sendClick({
        action: 'CHECK_OUT_BUTTON',
        params: {
            is_free_shipping: is_free_shipping ? 1 : 0,
        },
    });
};

export const logClickAddToCartButton = () => {
    logger.sendClick({
        action: 'ADD_TO_CART_BUTTON',
    });
};

export const logShowHalfScreenPopup = (item_count) => {
    logger.sendShow({
        action: 'ADD_ON_HALF_SCREEN',
        params: {
            item_count,
        },
    });
};

export const logClickAddOnTab = (tab_name) => {
    logger.sendClick({
        action: 'ADD_ON_TAB',
        params: {
            tab_name,
        },
    });
};

export const logShowPriceReduction = (amt, skuId) => {
    logger.sendShow({
        action: 'PRICE_REDUCTION',
        params: {
            amt,
            sku_id: skuId,
        },
    });
};

export const logShowValueTag = (tag, skuId) => {
    logger.sendShow({
        action: 'VALUE_TAG',
        params: {
            tag,
            sku_id: skuId,
        },
    });
};

export const logShowSpecEditor = ({ canEdit }: { canEdit: boolean }) => {
    logger.sendShow({
        action: 'PRODUCT_SPEC_MODE',
        params: {
            sku_type: canEdit ? 1 : 0,
        },
    });
};

export const logClickSpecEditor = ({ canEdit }: { canEdit: boolean }) => {
    logger.sendClick({
        action: 'PRODUCT_SPEC_MODE',
        params: {
            sku_type: canEdit ? 1 : 0,
        },
    });
};

export const logShowReselectSpec = () => {
    logger.sendShow({
        action: 'RESLECT_BUTTON',
        params: {},
    });
};

export const logClickReselectSpec = () => {
    logger.sendClick({
        action: 'RESLECT_BUTTON',
        params: {},
    });
};

export const logShowCartSpecPopup = () => {
    logger.sendShow({
        action: 'SPEC_LAYER',
        params: {},
    });
};

export const logClickSpecPopupConfirm = ({ isSuccess }: { isSuccess: boolean }) => {
    logger.sendClick({
        action: 'SPEC_LAYER_CONFIRM_BUTTON',
        params: {
            add_type: isSuccess ? 1 : 0,
        },
    });
};

export const onKwaiGlodVisible = () => {
    logger.sendShow({
        action: 'KWAI_GOALS_TAG',
        params: {},
    });
};
